import React from "react";
import { Col, Row, Card } from "antd";
import circles from "../images/circles.svg";
import { TryProduct } from "./TryTheProduct";

interface userProp { currentUser: any; }

const Circles: React.FC<userProp> = ({ currentUser }) =>  {
  return (
    <Card style={{pointerEvents: 'none', cursor: 'default'}} hoverable bodyStyle={{width: '100%'}} className={currentUser ? "product-layout product-layout-logged" : "product-layout"}>
      <div>
      <Row>
        <Col>
        <div className="product-description-img circles">
          <div className="product-img-border">
            <img
              className="product-img"
              src={circles}
              height="100%"
              alt="circles-logo"
            />
          </div>
        </div>
        </Col>
        </Row>
        <p className="eyebrow-text">Share and connect with your peers</p>
        <h2 className="h2 h2-circles">Circles</h2>
        <p className="p" style={{width: '100%'}}>
        As Science Central evolves, you can connect and collaborate to share research findings. 
        </p>
        </div>
        <p className="typography">Coming in 2025</p>
        </Card>
  );
};

export default Circles;
